import React from "react"
import { Field, Formik, Form } from "formik"
import PropTypes from "prop-types"
import _get from "lodash/get"

import Typograph from "components/Typograph"
import ModernFloatLabelInput from "shared/components/ModernFloatLabelInput"
import FileUploadField from "../FileUploadField"
import HeaderForm from "../HeaderForm"
import FooterForm from "../FooterForm"

import styles from "./styles.css"

import { maskCPF, maskTel, date, maskCNPJ } from "services/utils/mask"
import { stepOneValidation } from "../validationForm"

function CustomerDataStep({
  onNextStep,
  setFormData,
  onClose,
  customer,
  formData,
  initialForm
}) {
  const documentNumber = _get(customer, "documentNumber", "")
  const { name, cpf, birthDate, phoneNumber, email, fileRG } = formData

  const handleChangeNextStep = (values) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        ...values
      }
    })
    onNextStep()
  }

  const handleChangeOnClose = () => {
    setFormData(initialForm)
    onClose()
  }

  return (
    <div>
      <HeaderForm
        title="Abrir solicitação de adesão"
        description="Preencha os dados abaixo para simular sua economia e iniciar o processo
        de adesão:"
      />

      <ModernFloatLabelInput
        id="CNPJ"
        label="CNPJ da empresa"
        value={maskCNPJ(documentNumber)}
        disabled
      />

      <div className={styles.form}>
        <Typograph
          htmlTag="h2"
          size="medium"
          weight="medium"
          color="outer_space"
        >
          Dados do responsável legal
        </Typograph>
        <Typograph
          htmlTag="p"
          size="extra_small"
          weight="regular"
          color="outer_space"
        >
          Pessoa autorizada a representar e compartilhar documentos em nome da
          empresa.
        </Typograph>

        <div>
          <Formik
            initialValues={{ name, cpf, birthDate, phoneNumber, email, fileRG }}
            validationSchema={stepOneValidation}
            validateOnMount
            enableReinitialize
          >
            {({ isValid, values }) => (
              <Form>
                <Field name="name">
                  {({ field, meta }) => (
                    <ModernFloatLabelInput
                      {...field}
                      id="name"
                      label="Nome completo*"
                      error={meta.touched && meta.error}
                    />
                  )}
                </Field>
                <div className={styles.gridForm}>
                  <Field name="cpf">
                    {({ field, meta, form }) => (
                      <ModernFloatLabelInput
                        {...field}
                        id="cpf"
                        label="CPF*"
                        error={meta.touched && meta.error}
                        maxLength={14}
                        onChange={(e) => {
                          const masked = maskCPF(e.target.value)
                          form.setFieldValue(field.name, masked)
                        }}
                      />
                    )}
                  </Field>
                  <Field name="birthDate">
                    {({ field, meta, form }) => (
                      <ModernFloatLabelInput
                        {...field}
                        id="birthDate"
                        label="Data de nascimento*"
                        error={meta.touched && meta.error}
                        onChange={(e) => {
                          const masked = date(e.target.value)
                          form.setFieldValue(field.name, masked)
                        }}
                      />
                    )}
                  </Field>
                </div>

                <div className={styles.gridForm}>
                  <Field name="phoneNumber">
                    {({ field, meta, form }) => (
                      <ModernFloatLabelInput
                        {...field}
                        id="phoneNumber"
                        label="Celular*"
                        error={meta.touched && meta.error}
                        maxLength={15}
                        onChange={(e) => {
                          const masked = maskTel(e.target.value)
                          form.setFieldValue(field.name, masked)
                        }}
                      />
                    )}
                  </Field>
                </div>

                <Field name="email">
                  {({ field, meta }) => (
                    <ModernFloatLabelInput
                      {...field}
                      id="email"
                      label="E-mail*"
                      error={meta.touched && meta.error}
                    />
                  )}
                </Field>

                <div>
                  <Typograph
                    htmlTag="h3"
                    size="small"
                    weight="semi_bold"
                    color="outer_space"
                  >
                    RG ou CNH
                  </Typograph>

                  <Typograph
                    htmlTag="p"
                    size="small"
                    weight="medium"
                    color="outer_space"
                  >
                    As informações serão usadas apenas para elaborar a proposta,
                    em conformidade com as políticas de privacidade.
                  </Typograph>

                  <FileUploadField name="fileRG" document="RG ou CNH" />
                </div>

                <FooterForm
                  onClickNext={() => handleChangeNextStep(values)}
                  onClickPrevious={handleChangeOnClose}
                  step="1"
                  disabled={!isValid}
                  textPrevious="Cancelar"
                  textNext="Avançar"
                  type="button"
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}
CustomerDataStep.propTypes = {
  onNextStep: PropTypes.func,
  onClose: PropTypes.func,
  setFormData: PropTypes.func,
  customer: PropTypes.object,
  formData: PropTypes.object,
  initialForm: PropTypes.object
}
export default CustomerDataStep



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/RequestForm/components/CustomerDataStep/index.js